export const APP_VERSION = __APP_VERSION__;
export const BUILD_DATE = __BUILD_DATE__;
